import { render, staticRenderFns } from "./CRUDTrechos.vue?vue&type=template&id=888fa148&"
import script from "./CRUDTrechos.vue?vue&type=script&lang=js&"
export * from "./CRUDTrechos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports